import React from 'react';
import {Redirect, Route} from 'react-router-dom';

export default ({component: Component, allowed, redirectUrl, ...rest}) => {
    return <Route {...rest} render={props => (
        allowed
            ? <Component {...rest} />
            : <Redirect to={{pathname: redirectUrl, state: {from: props.location}}}/>
    )}/>
}